import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider } from './components/SidebarNew/ui/sidebar';
import { AppSidebar } from './components/SidebarNew/AppSidebar';
import { DashboardHeader } from './components/Header/DashboardHeader';
import styles from './Layout.module.scss';

interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

export default function DashboardLayout({ className, contentClassName, children }: LayoutProps) {
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const user = {
    email: storedUser.email || storedUser.info?.email || '',
    fullname: storedUser.fullname || storedUser.name || storedUser.first_name || storedUser.info?.fullname || '',
    avatar_url: storedUser.avatar || storedUser.avatar_url || storedUser.info?.avatar || '',
    roleName: storedUser.role?.name || storedUser.info?.role?.name || '',
  };

  const handleLogout = () => {
    // console.log('Logging out...');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate('/admin/profile');
  };

  return (
    <SidebarProvider defaultOpen={true} className='layout-none-widget-left'>
      <div className={styles.dashboardLayout}>
        {/* Header Area */}
        <div className="mainContent">
          <DashboardHeader
            user={user}
            onLogout={handleLogout}
            onProfileClick={handleProfileClick}
          />

          {/* Page Content */}
          <main>
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
